import { render, staticRenderFns } from "./MenuInferiore.vue?vue&type=template&id=cee5cbba&"
import script from "./MenuInferiore.vue?vue&type=script&lang=js&"
export * from "./MenuInferiore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports